import angular from 'angular';

export const IfPerm = (ProfilePermissionsService) => {
  'ngInject';

  var $permissions = ProfilePermissionsService;
  return {
    restrict: 'A',
    link ($scope, $element, $attrs) {
      var showPermList, hidePermList, disablePermList;

      function meet(perms) {
        return $permissions.isAdmin() || $permissions.hasAtLeastOneOf(perms);
      }

      if (angular.isDefined($attrs.showIf)) {
        showPermList = $attrs.showIf.split(',').map(i => i.trim()).filter(i => !!i);
        if (!meet(showPermList)) {
          $element.addClass('hidden');
        }
      }
      else if (angular.isDefined($attrs.hideIf)) {
        hidePermList = $attrs.hideIf.split(',').map(i => i.trim()).filter(i => !!i);
        if (meet(hidePermList)) {
          $element.addClass('hidden');
        }
      } else if (angular.isDefined($attrs.disableIf)) {
        disablePermList = $attrs.disableIf.split(',').map(i => i.trim()).filter(i => !!i);
        if (!meet(disablePermList)) {
          $element.attr('disabled', 'disabled');
          $element.addClass('disabled');
        }
      }

      $element.on('$destroy', () => {
        showPermList = null;
        hidePermList = null;
        disablePermList = null;
      });
    }
  };
};


// WEBPACK FOOTER //
// ./src/app/directives/if-perm.directive.js